import * as React from 'react';
import * as unitedway from '../../../../assets/images/unitedway_horizontal.png';

export class UnitedWayListItem extends React.Component<{}> {
  public render() {
    return <img src={unitedway} width="152" height="31" />;
  }
}
